import React from 'react';
import './full-page-dialog.scss';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import Typography from '@material-ui/core/Typography';
import NewExpenseForm from '../NewExpenseForm';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);


const NewExpenseDialog = ({ open, handleClose }) => (
  <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} classes={{ paperFullScreen: 'dialog-bg' }}>
    <AppBar className="appBar" color="inherit" style={{ position: 'relative', boxShadow: 'none' }}>
      <Toolbar variant="dense" disableGutters elevation={0}>
        <IconButton edge="start" onClick={handleClose} aria-label="close">
          <FontAwesomeIcon style={{ fontSize: 16 }} icon={faChevronLeft} />
        </IconButton>
        <Typography variant="h6" className="toolbar-title title-type">
              Nuevo Gasto
        </Typography>
      </Toolbar>
    </AppBar>
    <NewExpenseForm />
  </Dialog>

);

export default NewExpenseDialog;
